<div class="bg-white rounded-lg shadow-sm text-base" [ngClass]="extraClass? extraClass: 'w-full h-full'">
    <!-- Inital Page -->
    <div *ngIf="selectedView === 'INITIAL'" class="h-full w-full">
        <div (click)="switchView('RECURRING_ROUTE_MASTER')"
            class="flex items-center primary-font text-base text-gray-700 gap-2.5 p-4 border-b hover:bg-gray-100 cursor-pointer">
            <i class="ti ti-repeat text-2xl text-blue"></i>
            <span class="font-semibold flex-1">{{'dispatchBoard.routes.tbar.route_type.recurring_routes' |
                translate}}</span>
            <i class="ti ti-chevron-right text-2xl"></i>
        </div>
        <div (click)="switchView('ONE_OFF_ROUTES')"
            class="flex items-center primary-font text-base text-gray-700 gap-2.5 p-4 border-b hover:bg-gray-100 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="gray"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-repeat-once">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
                <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
                <path d="M11 11l1 -1v4" />
            </svg>
            <span class="font-semibold flex-1">{{'text.one_off_route' | translate}}</span>
            <i class="ti ti-chevron-right text-2xl"></i>
        </div>
    </div>
    <!-- One-off routes -->
    <div *ngIf="selectedView === 'ONE_OFF_ROUTES'" class="h-full w-full">
        <div class="flex items-center primary-font text-base text-gray-700 gap-2.5 p-4 border-b">
            <button class="p-1 hover:bg-gray-100 rounded-lg" (click)="switchView('INITIAL')"><i
                    class="ti ti-chevron-left text-2xl"></i></button>
            <span class="font-semibold flex-1">{{'recurring_route.select_route' | translate}}</span>
        </div>
        <!-- One-off route search -->
        <div class="flex items-center primary-font font-medium text-base text-gray-700 gap-2.5 p-4 border-b">
            <mat-form-field appearance="fill" class="w-full custom-form-field flex items-center">
                <button matPrefix aria-label="Search">
                    <i class="ti ti-search text-xl font-medium block"></i>
                </button>
                <input matInput class="w-full h-8" [(ngModel)]="routePagination[routeType].keyword"
                    placeholder="{{'placeholder.search_routes' | translate}}"
                    (keyup)="routeSearch($event)"
                    (blur)="routePagination[routeType].keyword = routeParam[routeType]['filter.keyword'] || ''">
                <button mat-button matSuffix mat-icon-button aria-label="Clear"
                    *ngIf="routePagination[routeType]?.keyword?.length"
                    (click)="routePagination[routeType].keyword='';routeSearch($event, 'clear')">
                    <mat-icon class="text-2xl font-medium hover:bg-gray-100 rounded-full">close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <!-- One-off routes list -->
        <div class="route-list w-full overflow-y-auto zuper-scrollbar">
            <div class="primary-font text-base font-normal text-gray-700 gap-2.5">
                <div class="w-full border-b p-4"
                    (click)="routeUid !== oneOffRoute?.route_uid && actionEventEmitter({isSelected: true, data: oneOffRoute, type: routeType})"
                    *ngFor="let oneOffRoute of routeList[routeType];"
                    [ngClass]="routeUid === oneOffRoute?.route_uid? 'bg-gray-200 cursor-not-allowed': 'hover:bg-gray-100 cursor-pointer'">
                    <div class="space-y-1 primary-font text-base font-normal text-gray-700">
                        <div class="flex items-center">
                            <span class="flex-1 block truncate"
                                title="{{oneOffRoute?.route_name || ''}}">
                                <div class="flex items-center space-x-1 truncate">
                                    <i class="ti ti-lock text-2xl text-red-500" title="{{'dispatchBoard.scheduler.route.locked' | translate}}" *ngIf="oneOffRoute?.is_locked"></i>
                                    <span class="block truncate">{{oneOffRoute?.route_name || ''}}</span>
                                </div>
                            </span>
                            <div class="max-w-fit text-gray-500"> {{oneOffRoute?.total_jobs}}
                                {{(oneOffRoute?.total_jobs > 1? 'text.jobs': 'job' ) | translate}} 
                            </div>
                        </div>
                        <div class="flex items-center text-gray-500 primary-font font-medium text-base justify-between">
                            <span>{{oneOffRoute?.startDateTime}}</span>
                            <span>{{oneOffRoute?.duration}} {{'route.hours' | translate}}</span>
                        </div>
                        <!-- Progress bar -->
                        <div class="mt-1">
                            <div class="flex justify-between mb-1">
                                <span
                                    class="text-base font-medium text-gray-700 dark:text-white">{{oneOffRoute?.utilisedPercentage
                                    || 0}}% {{'text.utilised' | translate}}</span>
                                <span
                                    class="text-base font-normal text-gray-500 dark:text-white">{{oneOffRoute?.routeHoursRemaining
                                    || '0h'}} {{'text.remaining' | translate}}</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div class="bg-blue-600 h-2.5 rounded-full"
                                    [style.width.%]="oneOffRoute?.utilisedPercentage || 0"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex item-center justify-center">
                    <lazy-loader class="p-4" *ngIf="routePagination[routeType].isLoading"></lazy-loader>
                    <span class="p-4 font-medium" *ngIf="!routeList[routeType]?.length && !routePagination[routeType].isLoading">
                        {{'text.no_routes_found' | translate}}
                    </span>
                    <span class="font-medium hover:bg-gray-100 mt-2 p-2 px-4 rounded-lg cursor-pointer "
                        (click)="loadMoreRoutes();"
                        *ngIf="routePagination[routeType].totalPages > routePagination[routeType].currentPage && !routePagination[routeType].isLoading">{{'text.load_more'
                        | translate}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- Recurring route master -->
    <div *ngIf="selectedView === 'RECURRING_ROUTE_MASTER'" class="h-full w-full">
        <div class="flex items-center primary-font text-base text-gray-700 gap-2.5 p-4 border-b">
            <button class="p-1 hover:bg-gray-100 rounded-lg" (click)="switchView('INITIAL')"><i
                    class="ti ti-chevron-left text-2xl"></i></button>
            <span class="font-semibold flex-1">{{'text.go_back' | translate}}</span>
        </div>
        <!-- Recurring route master search -->
        <div class="flex items-center primary-font font-medium text-base text-gray-700 gap-2.5 p-4 border-b">
            <mat-form-field appearance="fill" class="w-full custom-form-field flex items-center">
                <button matPrefix aria-label="Search">
                    <i class="ti ti-search text-xl font-medium block"></i>
                </button>
                <input matInput class="w-full h-8" (keyup)="routeSearch($event)"
                    (blur)="routePagination[routeType].keyword = routeParam[routeType]['filter.keyword'] || ''"
                    [(ngModel)]="routePagination[routeType].keyword"
                    placeholder="{{'text.search_recurring_routes' | translate}}">
                <button mat-button matSuffix mat-icon-button aria-label="Clear"
                    *ngIf="routePagination[routeType].keyword?.length"
                    (click)="routePagination[routeType].keyword='';routeSearch($event, 'clear')">
                    <mat-icon class="text-2xl font-medium hover:bg-gray-100 rounded-full">close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <!-- Recurring route master list -->
        <div class="route-list w-full overflow-y-auto zuper-scrollbar">
            <div class="primary-font font-medium text-base text-gray-700 flex flex-col space-y-2">
                <div (click)="switchView('RECURRING_ROUTE_INSTANCES', {recurringRouteMaster: masterRoute})"
                    *ngFor="let masterRoute of routeList[routeType];"
                    class="w-full p-4 border-b cursor-pointer space-y-1.5 hover:bg-gray-100">
                    <div class="flex items-center gap-2 justify-between ">
                        <div class="flex items-center">
                            <span>{{masterRoute?.recurring_route_name || ''}}</span>
                            <div class="bg-gray-200 px-2 py-1 min-w-fit mx-2 rounded-lg text-base h-fit"
                                *ngIf="recurringRouteMasterUid === masterRoute?.recurring_route_uid">
                                <span class="font-medium">{{'text.current_series' | translate}}</span>
                            </div>
                        </div>
                        <i class="ti ti-chevron-right text-2xl"></i>
                    </div>
                    <div class="flex items-center space-x-2 font-normal" *ngIf="masterRoute?.rrText">
                        <div class="min-w-fit">
                            <i class="ti ti-repeat text-2xl text-light-blue"></i>
                        </div>
                        <div class="flex items-center space-x-1">
                            <span>{{'text.repeats' | translate}} {{masterRoute?.rrText}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex item-center justify-center ">
                <lazy-loader class="p-4" *ngIf="routePagination[routeType].isLoading"></lazy-loader>
                <span class="font-medium hover:bg-gray-100 mt-2 p-2 px-4 rounded-lg cursor-pointer "
                    (click)="loadMoreRoutes();"
                    *ngIf="routePagination[routeType].totalPages > routePagination[routeType].currentPage && !routePagination[routeType].isLoading">{{'text.load_more'
                    | translate}}</span>
            </div>
            <div class="p-4" *ngIf="!routePagination[routeType].isLoading && !routeList[routeType]?.length">
                <span class="font-medium">{{'recurring_route.no_recurring_route' | translate}}</span>
            </div>
        </div>
    </div>
    <!-- Recurring route Instanes -->
    <div *ngIf="selectedView === 'RECURRING_ROUTE_INSTANCES'" class="h-full w-full">
        <div class="flex items-center primary-font text-base text-gray-700 gap-2.5 p-4 border-b">
            <button class="p-1 hover:bg-gray-100 rounded-lg" (click)="switchView('RECURRING_ROUTE_MASTER')"><i
                    class="ti ti-chevron-left text-2xl"></i></button>
            <span class="font-semibold flex-1">{{'recurring_route.select_instance' | translate}}</span>
        </div>
        <div class="route-list without-search w-full overflow-y-auto zuper-scrollbar">
            <div class="primary-font text-base font-normal text-gray-700 gap-2.5">
                <div class="w-full border-b p-4"
                    (click)="routeUid !== recurringRouteInstance?.route_uid && actionEventEmitter({isSelected: true, data: recurringRouteInstance, type: routeType})"
                    *ngFor="let recurringRouteInstance of routeList[routeType];"
                    [ngClass]="routeUid === recurringRouteInstance?.route_uid? 'bg-gray-200 cursor-not-allowed': 'hover:bg-gray-100 cursor-pointer'">
                    <div class="space-y-1 primary-font text-base font-normal text-gray-700">
                        <div class="flex items-center">
                            <span class="flex-1 block truncate"
                                title="{{recurringRouteInstance?.route_name || ''}}">
                                <div class="flex items-center space-x-1 truncate">
                                    <i class="ti ti-lock text-2xl text-red-500" title="{{'dispatchBoard.scheduler.route.locked' | translate}}" *ngIf="recurringRouteInstance?.is_locked"></i>
                                    <span class="block truncate">{{recurringRouteInstance?.route_name || ''}}</span>
                                </div>
                                </span>
                            <div class="max-w-fit text-gray-500"> {{recurringRouteInstance?.total_jobs}}
                                {{(recurringRouteInstance?.total_jobs > 1? 'text.jobs': 'job' ) | translate}} </div>
                        </div>
                        <div class="flex items-center text-gray-500 primary-font font-medium text-base justify-between">
                            <span>{{recurringRouteInstance?.startDateTime}}</span>
                            <span>{{recurringRouteInstance?.duration}} {{'route.hours' | translate}}</span>
                        </div>
                        <!-- Progress bar -->
                        <div class="mt-1">
                            <div class="flex justify-between mb-1">
                                <span
                                    class="text-base font-medium text-gray-700 dark:text-white">{{recurringRouteInstance?.utilisedPercentage
                                    || 0}}% {{'text.utilised' | translate}}</span>
                                <span
                                    class="text-base font-normal text-gray-500 dark:text-white">{{recurringRouteInstance?.routeHoursRemaining
                                    || '0 hr'}} {{'text.remaining' | translate}}</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div class="bg-blue-600 h-2.5 rounded-full"
                                    [style.width.%]="recurringRouteInstance?.utilisedPercentage || 0"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex item-center justify-center ">
                    <lazy-loader class="p-4" *ngIf="routePagination[routeType].isLoading"></lazy-loader>
                    <span class="p-4 font-medium" *ngIf="!routeList[routeType]?.length && !routePagination[routeType].isLoading">
                        {{'text.no_routes_found' | translate}}
                    </span>
                    <span class="font-medium hover:bg-gray-100 mt-2 p-2 px-4 rounded-lg cursor-pointer "
                        (click)="loadMoreRoutes();"
                        *ngIf="routePagination[routeType].totalPages > routePagination[routeType].currentPage && !routePagination[routeType].isLoading">{{'text.load_more'
                        | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>